import { render } from "./CompetentionTitle.vue?vue&type=template&id=45ffd1b5"
import script from "./CompetentionTitle.vue?vue&type=script&lang=js"
export * from "./CompetentionTitle.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__